import React from 'react';
import { useNavigate } from 'react-router-dom';
import FooterMenu from 'Components/FooterMenu';
import { Container, Grid, Typography, Button } from '@mui/material';
import { makeStyles } from '@mui/styles';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { ReactComponent as LogoIcon } from "assets/logo.svg";
import { useTranslation } from 'react-i18next';

const clStyles = makeStyles(() => ({
	grid: {
		minHeight: 'calc(100vh - 300px)'
	},
	fill: {
		height: '100%',
		width: '100%'
	},
	logoWrapper: {
		width: '100%',
		textAlign: 'center',
		marginTop: '20px',
		marginBottom: '10px !important',
	},
	logoHeader: {
		flexGrow: 1,
		maxWidth: '60%',
	},
	imageContainer: {
		// marginTop: '15px',
		width: '100%',
		textAlign: 'center',
	},
	welcomeImage: {
		width: '80%',
	},
	contentWrapper: {
		width: '80%',
		marginTop: '15px',
		textAlign: 'center',
	},
	greenButton: {
		width: '100%',
		height: '38px',
		backgroundColor: '#93FF50 !important',
		color: '#000 !important',
		textTransform: 'uppercase',
		marginTop: '10px !important',
	},
	whiteButton: {
		width: '100%',
		height: '38px',
		backgroundColor: '#fff !important',
		color: '#000 !important',
		textTransform: 'uppercase',
		marginTop: '10px !important',
	},
	redButton: {
		width: '100%',
		height: '38px',
		backgroundColor: '#FC5F5C !important',
		color: '#000 !important',
		textTransform: 'uppercase',
		marginTop: '10px !important',
		marginBottom: '20px !important',
	}

}));

const Welcome = (props) => {
	const navigate = useNavigate();
	const { t } = useTranslation();
	const { notCentered, className, fill } = props
	const classes = clStyles()
	const gridClasses = cx({
		[classes.grid]: notCentered,
		[classes.fill]: fill,
		[className]: className ? true : false
	})

	const handleScanDevice = () => {
		navigate('/scandevice');
	}

	return (
		<Container component="main" maxWidth="sm">
			<Grid container justifyContent={'center'} alignItems='center' className={gridClasses} style={props.style}>
				<div className={classes.logoWrapper}>
					<LogoIcon className={classes.logoHeader} />
				</div>
				<div className={classes.imageContainer}>
					<img src="/assets/welcome.png" alt="Skyen" className={classes.welcomeImage} />
				</div>
				<div className={classes.contentWrapper}>
					<p><Typography variant="body2" className={classes.title}>{t('Gennemgå opsætningsguiden før du registrerer produktet.')}</Typography></p>
					<p><Typography variant="body2" className={classes.title}>{t('Har du ikke abonnement? Læs mere om fordelene samt priser ved at trykke på “Køb abonnement”.')}</Typography></p>
				</div>
				<div className={classes.contentWrapper}>
					<Button onClick={()=> window.open("https://help.aabn.io/da/articles/10449386-opsaetningsguide", "_blank")} variant="contained" className={classes.greenButton}>{t('Opsætningsguide')}</Button>
					<Button onClick={handleScanDevice} variant="contained" className={classes.whiteButton}>{t('Produktregistrering')}</Button>
					<Button onClick={()=> window.open("https://aabn.io/collections/tilbehor/products/inside", "_blank")} variant="contained" className={classes.redButton}>{t('Køb abonnement')}</Button>
				</div>
			</Grid>
			<FooterMenu activeMenu={0} />
		</Container>
	)

}
Welcome.propTypes = {
	notCentered: PropTypes.bool
}

export default Welcome;